import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SdkInsightSectionComponent } from '../sdk-insight-section';

@Component({
  selector: 'app-sdk-overview-risks-v2',
  templateUrl: './sdk-overview-risks-v2.component.html',
  styleUrls: ['./sdk-overview-risks-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SdkOverviewRisksV2Component extends SdkInsightSectionComponent {
  data: any;

  constructor() {
    super();
    this._sdkInsightStateService.sdk$.subscribe(data => {
      this.data = data;
    });
  }
}
